import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Buefy from "buefy";
import "buefy/dist/buefy.css";
import "waveform-playlist/styles/playlist.scss";
import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faMicrophone,
  faTimes,
  faAngleLeft,
  faAngleRight,
  faArrowUp,
  faPlus,
  faMinus,
  faTimesCircle,
  faPlay,
  faStop,
  faCut,
  faGlobe,
  faSignOutAlt,
  faCaretDown,
  faCaretUp,
  faUser,
  faCog,
  faSpellCheck,
  faCheck,
  faQuestionCircle,
  faArrowsAltH,
  faIdBadge,
  faPause,
  faSearchPlus,
  faSearchMinus,
  faArrowRight,
  faChalkboardTeacher,
  faUsers,
  faShareAlt,
  faTrashAlt,
  faUserFriends,
  faStar,
  faCommentAlt,
  faBell,
  faCheckCircle
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import Vue2TouchEvents from "vue2-touch-events";

import "lazysizes";

library.add(
  faMicrophone,
  faTimes,
  faAngleLeft,
  faAngleRight,
  faArrowUp,
  faPlus,
  faMinus,
  faTimesCircle,
  faPlay,
  faStop,
  faCut,
  faGlobe,
  faSignOutAlt,
  faCaretDown,
  faCaretUp,
  faUser,
  faCog,
  faSpellCheck,
  faCheck,
  faQuestionCircle,
  faArrowsAltH,
  faIdBadge,
  faPause,
  faSearchPlus,
  faSearchMinus,
  faArrowRight,
  faChalkboardTeacher,
  faUsers,
  faShareAlt,
  faTrashAlt,
  faUserFriends,
  faStar,
  faCommentAlt,
  faBell,
  faCheckCircle
);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(Buefy, {
  defaultIconComponent: FontAwesomeIcon,
  defaultIconPack: "fas"
});

Vue.use(Vue2TouchEvents);

Vue.config.errorHandler = function(err, vm, info) {
  window.onerror(err, "Vue", 0, 0, info);
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
